export function getRootPath(location) {
    return `/${location.pathname.split("/")[1] ?? ""}`;
}
export function getStrippedPath(location) {
    // console.log("location.pathname", location.pathname);
    let qwe = location.pathname.split("/").filter((x) => x !== "");
    qwe.pop();
    // console.log("qwe", qwe);
    return `/${qwe.join("/")}`;
}
